import React from 'react';
import { observer } from "mobx-react-lite";
import { Layout } from "../modules/Layout";
import Plugins from "../modules/Component/Components/TablePlugin";

export const PluginPage = observer(() => {
    return (
        <Layout offset={{left: 1}}>
            <Plugins/>
        </Layout>
    )
});